<template>
  <div>
    <div class="p-lg-3">
      <div class="row">
        <h3 class="mt-0 mb-2 font-weight-bold text-left">
          Relatório - Serviços por tutor
        </h3>
      </div>
    </div>

    <v-row align="center" class="my-3">
      <v-col class="d-flex">
        <v-select
            :items="unidades"
            label="Unidade"
            item-value="id"
            v-model="unidadeSelected"
        ></v-select>
      </v-col>
      <v-col class="d-flex">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="datas"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="computedFormatDate"
                label="Data inicial - Data final"
                prepend-icon="mdi-calendar"
                clearable
                v-bind="attrs"
                v-on="on"
                @click:clear="datas = null"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="datas"
              no-title
              range
              scrollable
              color="green darken-4"
          >
            <v-spacer></v-spacer>
            <v-btn text @click="menu = false"> Cancelar</v-btn>
            <v-btn dark color="success" @click="$refs.menu.save(datas)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="d-flex">
        <v-select
            :items="execucaoList"
            item-text="descricao"
            item-value="id"
            label="Execução"
            v-model="execucaoSelected"
        ></v-select>
      </v-col>
      <v-col class="d-flex">
        <v-select
            :items="tipoList"
            item-text="descricao"
            item-value="id"
            label="Tipo"
            v-model="tipoSelected"
        ></v-select>
      </v-col>
      <v-col class="overflow-select">
        <v-select
            v-model="filtroPesquisaSelected"
            :items="filtroPesquisa"
            label="Procedimentos"
            item-text="nome"
            item-value="id"
            return-object
            multiple
        >
          <template v-slot:selection="{ item, index }">
<!--            <v-chip v-if="index === 0">-->
<!--              <span>{{ limitarCaracteres(item.nome) }}</span>-->
<!--            </v-chip>-->
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ filtroPesquisaSelected.length - 1 }} procedimentos)
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click="toggle">
              <v-list-item-action>
                <v-icon :color="likesAllProcedimento ? 'indigo darken-4' : ''">
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Selecionar Todos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-col>
      <v-col class="d-flex">
        <v-speed-dial
            v-model="fab"
            :direction="direction"
            :open-on-hover="hover"
        >
          <template v-slot:activator>
            <v-btn
                v-model="fab"
                style="
                color: #fff;
                background-color: #1daf80;
                border-radius: 50px;
              "
                color="blue darken-2"
                dark
                class="btnWid"
            >
              <v-icon v-if="fab"> mdi-close</v-icon>
              <span v-else> Exportar </span>
            </v-btn>
          </template>
<!--          <v-btn dark color="green" class="btnWid" @click="pdfRelatorioServicosTutor">-->
<!--            PDF-->
<!--          </v-btn>-->
          <v-btn dark color="indigo" class="btnWid" @click="excelRelatorioServicosTutor">
            EXCEL
          </v-btn>
        </v-speed-dial>
      </v-col>
    </v-row>
    <v-progress-circular v-if="loading"
        indeterminate
        color="1daf80"
    ></v-progress-circular>
  </div>
</template>
<script>
import UnidadeService from "@/services/unidade_service";
import ProcedimentoService from "@/services/procedimento_service";
import Mixin from "@/mixins/vuex_mixin.js";
import TipoProcedimentoService from "../services/tipo_procedimento_service";
export default {
  mixins: [Mixin],
  data: () => ({
    filtroPesquisaSelected: "",
    filtroPesquisa: [],
    datas: null,
    menu: false,
    loading: false,
    perfil: "",
    direction: "bottom",
    left: false,
    hover: false,
    fab: false,
    unidades: [],
    unidadeSelected: "",
    services: {
      unidadeService: UnidadeService.build(),
      procedimentoService: ProcedimentoService.build(),
      TipoProcedimentoService: TipoProcedimentoService.build(),
    },
    execucaoList: [
      {descricao: "Executado", id: 2},
      {descricao: "Não executado", id: 1},
      {descricao: "Todos", id: 3},
    ],
    execucaoSelected: "",
    tipoList: [{descricao: "Todos", id: 0},],
    tipoSelected: "",
    procedimentoId: "",
  }),
  watch: {
    async tipoSelected() {
      //this.filtroPesquisa = [{ id: 0, nome: "Todos" }];

      // Verifique se o tipo selecionado não é "Todos" (id 11)
      this.likesAllProcedimento = false;
      this.toggle();
      if (this.tipoSelected !== 0 && this.unidadeSelected) {
        this.loadingFiltroPesquisa = true;

        // Chame o serviço para obter os procedimentos correspondentes
        this.filtroPesquisa = [];
        this.filtroPesquisa = this.filtroPesquisa.concat(
            await this.services.procedimentoService
                .getProcedimentosPorUnidadeEprocedimento(
                    this.unidadeSelected,
                    this.tipoSelected ?? 0
                )
                .then((resp) => {
                  console.log(resp);
                  return resp.map((item) => {
                    return {
                      id: item.procedimento_id,
                      nome: item.procedimento_descricao,
                    };
                  });
                })
        );

        this.loadingFiltroPesquisa = false;
      }
      if (this.tipoSelected === 0 && this.unidadeSelected) {
        this.loadingFiltroPesquisa = true;

        // Chame o serviço para obter os procedimentos correspondentes
        this.filtroPesquisa = [];
        this.filtroPesquisa = this.filtroPesquisa.concat(
            await this.services.procedimentoService
                .getProcedimentosPorUnidadeRelatorio(this.unidadeSelected)
                .then((resp) => {
                  console.log(resp);
                  return resp.map((item) => {
                    return {
                      id: item.procedimento_id,
                      nome: item.procedimento_descricao,
                    };
                  });
                })
        );

        this.loadingFiltroPesquisa = false;
      }
    },
  },
  beforeMount() {
    this.perfil = JSON.parse(sessionStorage.vuex).perfil.id;
    if (this.perfil === 6) {
      this.tipoList = [{descricao: "Todos", id: 3}];
      this.tipoSelected = this.tipoList[0].id;
    }
    this.setServicos();

      this.setUnidades();
  },
  computed: {
    computedFormatDate() {
      const datasFormatadas =
          this.datas &&
          this.datas.map((item) =>
              item
                  .split("-")
                  .reverse()
                  .join("/")
          );
      return datasFormatadas;
    },
    likesAllProcedimento() {
      return this.filtroPesquisaSelected.length === this.filtroPesquisa.length;
    },
    likesSomeProcedimento() {
      return (
          this.filtroPesquisaSelected.length > 0 && !this.likesAllProcedimento
      );
    },
    icon() {
      if (this.likesAllProcedimento) return "mdi-close-box";
      if (this.likesSomeProcedimento) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    async setServicos() {
      await this.services.TipoProcedimentoService
          .getTipoProcedimentos()
          .then((resp) => resp.json())
          .then((resp) =>
              resp.data.tipo_procedimentos.filter((p) => p.id != 1 && p.id != 7)
          )
          .then((resp) => resp.map((p) => this.tipoList.push(p)));
      console.log('tipo dos fitro oh doi ', this.tipoList);
    },
    setUnidades() {
      this.services.unidadeService
          .getUnidadeByUsuarioLogado()
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            this.unidades = response.data.map((unidade) => {
              return {text: unidade.unidade, id: unidade.id_unidade};
            });
          });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllProcedimento) {
          this.filtroPesquisaSelected = [];
        } else {
          this.filtroPesquisaSelected = [...this.filtroPesquisa];
        }
      });
    },
    // pdfRelatorioServicosTutor() {
    //   this.loadingTable = true;
    //
    //   const dataInicial = this.datas ? this.datas[0].split("-").join("") : "";
    //   const dataFinal = this.datas ? this.datas[1].split("-").join("") : "";
    //   const unidade = this.unidadeSelected ? this.unidadeSelected : "";
    //   const tipoProcedimento = this.tipoSelected;
    //
    //   const filtroPesquisaIds = this.filtroPesquisaSelected.map(
    //       (item) => item.id
    //   );
    //
    //   if (
    //       !dataInicial ||
    //       !dataFinal ||
    //       !unidade ||
    //       (tipoProcedimento !== 0 && !tipoProcedimento)
    //   ) {
    //     this.$_ACTIONS_showSnackbarMessage({
    //       message: "Preencha os campos corretamente",
    //       color: "error",
    //     });
    //     this.loadingTable = false;
    //     return;
    //   }
    //
    //   this.services.procedimentoService
    //       .pdfRelatorioServicosTutor(
    //           dataInicial,
    //           dataFinal,
    //           unidade,
    //           tipoProcedimento,
    //           filtroPesquisaIds
    //       )
    //       .then((resp) => {
    //         if (resp.status) {
    //           this.$_ACTIONS_showSnackbarMessage({
    //             message: "Falha ao carregar",
    //             color: "error",
    //           });
    //           console.log( dataInicial,
    //               dataFinal,
    //               unidade,
    //               tipoProcedimento,
    //               filtroPesquisaIds)
    //           return;
    //         }
    //         this.$_ACTIONS_showSnackbarMessage({
    //           message: "Dados encontrados com sucesso! Gerando PDF...",
    //           color: "sucess",
    //         });
    //         let link = document.createElement("a");
    //         // link.target = "_blank";
    //         link.download = `${dataInicial}-${dataFinal}.pdf`;
    //         let url = window.URL.createObjectURL(resp);
    //         link.href = url;
    //         link.click();
    //         console.log(resp)
    //       })
    //       .catch(() => {
    //         this.$_ACTIONS_showSnackbarMessage({
    //           message: "Falha ao carregar",
    //           color: "error",
    //         });
    //         console.log( dataInicial,
    //             dataFinal,
    //             unidade,
    //             tipoProcedimento,
    //             filtroPesquisaIds)
    //       })
    //       .finally(() => {
    //         this.loadingTable = false;
    //       });
    // },
    excelRelatorioServicosTutor() {
console.log('bateu no comeco')
      const dataInicial = this.datas ? this.datas[0].split("-").join("") : "";
      console.log('bateu no comecoDI')

      const dataFinal = this.datas ? this.datas[1].split("-").join("") : "";
      console.log('bateu no comecoDF')

      const unidade = this.unidadeSelected ? this.unidadeSelected : "";
      console.log('bateu no comecoU')

      const tipoProcedimento = this.tipoSelected ? this.tipoSelected : this.tipoSelected;
      console.log('bateu no comecoT', tipoProcedimento, this.tipoSelected);

      const filtroPesquisaIds = this.filtroPesquisaSelected ? this.filtroPesquisaSelected.map(
          (item) => item.id
      ) : [];
      console.log('bateu no comecoF', filtroPesquisaIds)

      this.loading = true;
      console.log('bateu no fim')

      if (dataInicial === '' || dataFinal === '' || unidade === '' || tipoProcedimento === '' || filtroPesquisaIds.length < 1 ) {
        console.log(dataInicial, dataFinal, unidade, tipoProcedimento, filtroPesquisaIds);
        this.$_ACTIONS_showSnackbarMessage({
          message: "Preencha os campos corretamente",
          color: "error",
        });
        this.loading = false;

        return;
      }

      this.services.procedimentoService
          .excelRelatorioServicosTutor(
              dataInicial,
              dataFinal,
              unidade,
              tipoProcedimento,
              filtroPesquisaIds
          )
          .then((resp) => {
            console.log(resp)
            if (resp.status) {
              this.$_ACTIONS_showSnackbarMessage({
                message: "Falha ao carregar",
                color: "error",
              });
              return;
            }
            this.$_ACTIONS_showSnackbarMessage({
              message:
                  "Dados encontrados com sucesso! Gerando arquivo para Excel...",
              color: "sucess",
            });
            let link = document.createElement("a");
            // link.target = "_blank";
            link.download = `${dataInicial}-${dataFinal}.xlsx`;
            let url = window.URL.createObjectURL(resp);
            link.href = url;
            link.click();
            this.loading = false;
          })
          .catch(() => {
            this.$_ACTIONS_showSnackbarMessage({
              message: "Falha ao carregar",
              color: "error",

            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // limitarCaracteres(string) {
    //   if (string.length > 10) {
    //     return string.substring(0, 10) + "...";
    //   } else {
    //     return string;
    //   }
    // },
  },
}
</script>
<style scoped>
.btnWid {
  width: 7rem;
}

.v-progress-circular {
  margin: 1rem;
  color: #1daf80;
}

</style>